import { Link } from "react-router-dom";
import Seo from "@/components/Seo";
import { Eyebrow, Section, StatusChip } from "@/components/Type";
import { ARTICLES } from "@/content/articles";

export default function ThinkingPage() {
  return (
    <>
      <Seo
        title="W8ED Thinking | W8ED"
        description="W8ED Thinking — an editorial publication on the system of human health: nutrition, metabolism, muscle, movement, sleep, stress, recovery, behaviour and time."
        path="/thinking"
      />
      <section className="px-6 pb-20 pt-32 sm:pt-40">
        <div className="mx-auto max-w-6xl">
          <Eyebrow>Editorial</Eyebrow>
          <h1 className="mt-8 max-w-4xl font-display text-4xl font-extrabold leading-[1.05] tracking-tight text-[#f5f2ea] sm:text-6xl">
            W8ED THINKING.
          </h1>
          <p className="mt-8 max-w-2xl text-base leading-relaxed text-[#8e8a80]">
            An editorial publication on the system of human health. Pieces are published when they
            are ready — not before.
          </p>
        </div>
      </section>

      <Section className="py-0 sm:py-0">
        <div className="grid gap-px border border-[#1f1e1a] bg-[#1f1e1a] sm:grid-cols-2">
          {ARTICLES.map((a) => (
            <Link
              key={a.slug}
              to={`/thinking/${a.slug}`}
              data-testid={`article-card-${a.slug}`}
              className="group bg-[#0a0a09] p-8 transition-colors hover:bg-[#101009] sm:p-12"
            >
              <div className="flex items-center justify-between gap-4">
                <p className="font-mono text-[9px] tracking-[0.3em] text-[#C9A227]">
                  {a.topic.toUpperCase()}
                </p>
                <StatusChip status={a.status} />
              </div>
              <h2 className="mt-6 font-display text-2xl font-extrabold leading-tight tracking-tight text-[#f5f2ea] sm:text-3xl">
                {a.title}
              </h2>
              <p className="mt-4 text-sm leading-relaxed text-[#8e8a80]">{a.excerpt}</p>
            </Link>
          ))}
        </div>
      </Section>
      <div className="py-16" />
    </>
  );
}
